export const parentDashboardFr = {
  // Sections
  home: 'Accueil',
  myGrades: 'Mes Notes',
  quranProgress: 'Suivi Coran',
  myMessages: 'Mes Messages',
  logout: 'Déconnexion',
  
  // Welcome
  welcome: 'Bienvenue',
  parentOf: 'Parent de:',
  noLinkedStudents: 'Aucun étudiant lié',
  
  // Stats
  averageHifz: 'Moyenne Mémorisation',
  noSessionsToday: 'Aucune séance',
  averageGrades: 'Moyenne Notes',
  subjectsCount: 'Nombre de Matières',
  receivedMessages: 'Messages Reçus',
  sentMessages: 'Messages Envoyés',
  noReceivedMessages: 'Aucun message reçu',
  noSentMessages: 'Aucun message envoyé',
  hizbUnit: 'Hizb',
  
  // Messages
  recentMessages: 'Derniers Messages',
  noMessages: 'Aucun message',
  from: 'De:',
  to: 'À :',
  refresh: 'Actualiser',
  sendMessage: 'Envoyer un Message',
  selectStudent: 'Sélectionner l\'Étudiant',
  selectRecipient: 'Sélectionner le Destinataire',
  recipientTeacher: 'Professeur',
  recipientAdmin: 'Directeur',
  administration: 'Administration',
  teachers: 'Enseignants',
  messageSubject: 'Objet du Message',
  messagePlaceholder: 'Écrivez votre message ici...',
  sendButton: 'Envoyer',
  messageSent: 'Message envoyé avec succès',
  messageError: 'Erreur lors de l\'envoi du message',
  
  // Message priorities
  priorityNormal: 'Normale',
  priorityHigh: 'Élevée',
  priorityUrgent: 'Urgente',
  
  // Report types
  reportTypeAssignment: 'Devoir',
  reportTypeProgress: 'Rapport de Progrès',
  reportTypeAchievement: 'Réussite Exceptionnelle',
  reportTypeConcern: 'Note Importante',
  
  // Quran progress
  lastSession: 'Dernière Séance',
  newMemorization: 'Mémorisation Nouvelle',
  review: 'Révision',
  assignmentForNextSession: 'Devoir pour la Prochaine Séance',
  note: 'Note',
  hizbMemorized: 'Hizb Mémorisé',
  progressLevel: 'Niveau de Progrès',
  percentageOfQuran: 'du Coran',
  
  // Progress levels
  beginner: 'Débutant',
  intermediate: 'Intermédiaire',
  advanced: 'Avancé',
  veryAdvanced: 'Très Avancé',
  
  // Grades
  linkedStudentsGrades: 'Notes des Étudiants Liés',
  student: 'Étudiant',
  studentLabel: 'Étudiant(e)',
  subject: 'Matière',
  grade: 'Note',
  date: 'Date',
  comment: 'Commentaire',
  noGrades: 'Aucune note disponible',
  
  // Common
  update: 'Actualiser',
  loading: 'Chargement...',
  error: 'Erreur',
  retry: 'Réessayer',
  dateUnknown: 'Non spécifié',
  cancel: 'Annuler',
  optional: 'Optionnel',
  
  // Message
  message: 'Message',
  
  // Send message form
  selectAdminOrTeachers: 'Veuillez sélectionner l\'Administration ou les Enseignants ou les deux',
  selectStudentForTeachers: 'Veuillez sélectionner un étudiant pour envoyer le message aux enseignants',
  noTeachersForStudent: 'Aucun enseignant lié à cet étudiant. Veuillez contacter l\'administration.',
  messageWillBeSentToAdmins: 'Le message sera envoyé à tous les administrateurs',
  messageWillBeSentToAdminsOnly: 'Le message sera envoyé uniquement à tous les administrateurs',
  messageWillBeSentToAdminsAndTeachers: 'Le message sera envoyé à tous les administrateurs et aux enseignants de l\'étudiant sélectionné',
  messageWillBeSentToTeachersOnly: 'Le message sera envoyé uniquement aux enseignants de l\'étudiant sélectionné',
  selectStudentForTeachersMessage: 'Veuillez sélectionner un étudiant pour envoyer le message à ses enseignants',
  messageWillBeSentToAdminsSelectStudent: 'Le message sera envoyé à tous les administrateurs. Veuillez sélectionner un étudiant pour envoyer le message à ses enseignants.',
  
  // Password change
  changePassword: 'Changer le mot de passe',
  oldPassword: 'Ancien mot de passe',
  newPassword: 'Nouveau mot de passe',
  confirmPassword: 'Confirmer le mot de passe',
  enterOldPassword: 'Entrez l\'ancien mot de passe',
  enterNewPassword: 'Entrez le nouveau mot de passe',
  confirmNewPassword: 'Confirmez le nouveau mot de passe',
  passwordChangedSuccess: 'Mot de passe changé avec succès',
  errorChangingPassword: 'Erreur lors du changement de mot de passe',
  passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  fillAllFields: 'Veuillez remplir tous les champs',
  changing: 'Changement en cours...',

  // Branding & sender types
  associationName: 'Association Al-Falah',
  parentBoardSubtitle: 'Espace parent',
  senderTeacher: 'Professeur',
  senderAdmin: 'Administrateur',
  senderParent: 'Parent',
  notSpecified: 'Non spécifié',
};

